import http, { getAuthConfig } from './http';

const BASE_URL = '/home/banners';

const getBannerData = async () => {
  try {
    const response = await http.get(BASE_URL, getAuthConfig());
    return response.data.payload;
  } catch (error) {
    throw error;
  }
};

const getBannerById = async (id) => {
  try {
    const response = await http.get(`${BASE_URL}/${id}`, getAuthConfig());
    return response.data.payload;
  } catch (error) {
    throw error;
  }
};

export const SERVICE_BANNER = { 
  getBannerData, 
  getBannerById
};